import React from 'react'
import {Lang} from 'yougile-lang'
import {PermissionObject} from 'yougile-model'
import {
  allowAllOnColumn,
  ColumnPermissions,
  disallowAllOnColumn
} from 'yougile-model'
import {allowAllOnTask, disallowAllOnTask} from 'yougile-model'
import {
  PermissionsCheckbox,
  PermissionsHeader,
  PermissionsSelect,
  PermissionsTaskHeader
} from './permissions-settings-utils'
import {PermissionsTaskSettings} from './permissions-task-settings'

// eslint-disable-next-line max-lines-per-function
export const PermissionsColumnSettings = (props: {
  isSub?: boolean
  object: PermissionObject
  onChange: (obj: PermissionObject) => void
}) => {
  const {object, onChange, isSub} = props
  if (object.type !== 'column') {
    return null
  }
  const {permissions} = object
  const allTasks: PermissionObject = {
    type: 'task',
    permissions: permissions.allTasks,
    objectId: undefined
  }
  const allTasksChange = (t: PermissionObject) => {
    if (t.type !== 'task') {
      return
    }
    onChange({
      ...object,
      permissions: {...permissions, allTasks: t.permissions}
    })
  }
  const withMeTasks: PermissionObject = object.permissions.withMeTasks && {
    type: 'task',
    permissions: permissions.withMeTasks,
    objectId: undefined
  }
  const withMeTasksChange = (t: PermissionObject) => {
    if (!t) {
      onChange({
        ...object,
        permissions: {...permissions, withMeTasks: undefined}
      })
      return
    }
    if (t.type !== 'task') {
      return
    }
    onChange({
      ...object,
      permissions: {...permissions, withMeTasks: t.permissions}
    })
  }
  const myTasks: PermissionObject = object.permissions.myTasks && {
    type: 'task',
    permissions: permissions.myTasks,
    objectId: undefined
  }
  const myTasksChange = (t: PermissionObject) => {
    if (!t) {
      onChange({
        ...object,
        permissions: {...permissions, myTasks: undefined}
      })
      return
    }
    if (t.type !== 'task') {
      return
    }
    onChange({
      ...object,
      permissions: {...object.permissions, myTasks: t && t.permissions}
    })
  }
  const createdByMeTasks: PermissionObject = object.permissions
    .createdByMeTasks && {
    type: 'task',
    permissions: permissions.createdByMeTasks,
    objectId: undefined
  }
  const createdByMeTasksChange = (t: PermissionObject) => {
    if (!t) {
      onChange({
        ...object,
        permissions: {...permissions, createdByMeTasks: undefined}
      })
      return
    }
    if (t.type !== 'task') {
      return
    }
    onChange({
      ...object,
      permissions: {...object.permissions, createdByMeTasks: t && t.permissions}
    })
  }
  const moveOpts: Array<ColumnPermissions['move']> = ['no', 'project', 'yes']
  const allowAll = () => {
    onChange({...object, permissions: allowAllOnColumn(object.permissions)})
  }
  const disallowAll = () => {
    onChange({
      ...object,
      permissions: disallowAllOnColumn(object.permissions)
    })
  }
  const allowTasks =
    (key: 'allTasks' | 'myTasks' | 'withMeTasks' | 'createdByMeTasks') =>
    () => {
      onChange({
        ...object,
        permissions: {
          ...object.permissions,
          [key]: allowAllOnTask(object.permissions[key])
        }
      })
    }
  const disallowTasks =
    (key: 'allTasks' | 'myTasks' | 'withMeTasks' | 'createdByMeTasks') =>
    () => {
      onChange({
        ...object,
        permissions: {
          ...object.permissions,
          [key]: disallowAllOnTask(object.permissions[key])
        }
      })
    }
  const resetTasks =
    (key: 'allTasks' | 'myTasks' | 'withMeTasks' | 'createdByMeTasks') =>
    () => {
      onChange({
        ...object,
        permissions: {...object.permissions, [key]: undefined}
      })
    }
  return (
    <div className="flex flex-col gap-8">
      {!isSub && (
        <PermissionsHeader
          title={Lang.msg.permissionsColumn}
          allow={allowAll}
          disallow={disallowAll}
        />
      )}
      <PermissionsCheckbox {...props} path={['delete']} />
      <PermissionsCheckbox {...props} path={['editTitle']} />
      <PermissionsSelect {...props} path={['move']} options={moveOpts} />
      <PermissionsCheckbox {...props} path={['addTask']} />
      <PermissionsHeader
        title={Lang.msg.permissionsSettingsColumnAllTasks}
        allow={allowTasks('allTasks')}
        disallow={disallowTasks('allTasks')}
        isSub={true}
      />
      <PermissionsTaskSettings
        object={allTasks}
        onChange={allTasksChange}
        allowEmpty={false}
        isSub={true}
      />
      <PermissionsTaskHeader
        title={Lang.msg.permissionsSettingsColumnCreatedByMeTasks}
        allow={allowTasks('createdByMeTasks')}
        disallow={disallowTasks('createdByMeTasks')}
        reset={resetTasks('createdByMeTasks')}
        noActions={!createdByMeTasks}
      />
      <PermissionsTaskSettings
        object={createdByMeTasks}
        onChange={createdByMeTasksChange}
        allowEmpty={true}
        isSub={true}
      />
      <PermissionsTaskHeader
        title={Lang.msg.permissionsSettingsColumnMyTasks}
        allow={allowTasks('myTasks')}
        disallow={disallowTasks('myTasks')}
        reset={resetTasks('myTasks')}
        noActions={!myTasks}
      />
      <PermissionsTaskSettings
        object={myTasks}
        onChange={myTasksChange}
        allowEmpty={true}
        isSub={true}
      />
      <PermissionsTaskHeader
        title={Lang.msg.permissionsSettingsColumnWithMeTasks}
        allow={allowTasks('withMeTasks')}
        disallow={disallowTasks('withMeTasks')}
        reset={resetTasks('withMeTasks')}
        noActions={!withMeTasks}
      />
      <PermissionsTaskSettings
        object={withMeTasks}
        onChange={withMeTasksChange}
        allowEmpty={true}
        isSub={true}
      />
    </div>
  )
}
